import { EventEmitter, Injectable, OnInit } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarStateService implements OnInit {

  private expanded = false;
  public stateChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  private readonly localStorageKey = 'sidebar-expanded';

  constructor() {
    const savedState = localStorage.getItem(this.localStorageKey);
    this.expanded = savedState === 'true';
    this.stateChange.emit(this.expanded);
  }

  ngOnInit(): void {
    // This lifecycle hook is required by the OnInit interface
  }

  toggleSidebar(): void {
    this.expanded = !this.expanded;
    localStorage.setItem(this.localStorageKey, String(this.expanded));
    this.stateChange.emit(this.expanded);
  }

  isExpanded(): boolean {
    return this.expanded;
  }
}
